import { connect } from "react-redux";
import {
  clickPhoto,
  clickPager,
} from "@/shared/components/photo_gallery/actions";
import Gallery from "@/shared/components/photo_gallery/components/gallery";

// Component へ渡すパラメータ値
const mapStateToProps = (state) => {
  return {
    photos: state.gallery.filteredPhotos,
    page: state.gallery.page,
    accentColor: state.gallery.accentColor,
  };
};

// Component へ渡す Action
const mapDispatchToProps = (dispatch) => {
  return {
    clickPhoto: (...args) => dispatch(clickPhoto(...args)),
    clickPager: (...args) => dispatch(clickPager(...args)),
  };
};

// Component へパラメータを渡す
const connected = connect(mapStateToProps, mapDispatchToProps)(Gallery);

export default connected;
